import React from "react";
import AddAndUpdateBatch from "./AddAndUpdateBatch";

const AddBatch = () => {
  return <AddAndUpdateBatch />;
};

export default AddBatch;
